import { Action } from "redux"
import { IUserInfo } from "./index"

export const INITIALIZE = "USERMENU_INITIALIZE"
export const RECEIVE_HOME_PAGE_URL = "USERMENU_RECEIVE_HOME_PAGE_URL"
export const REQUEST_HOME_PAGE_URL = "USERMENU_REQUEST_HOME_PAGE_URL"
export const UPDATE_DEFAULT_NAVIGATION_TAB =
    "USERMENU_UPDATE_DEFAULT_NAVIGATION_TAB"

export interface Initialize extends Action {
    canCreateWorkspace: boolean
    fullName: string
    hasLogout: boolean
    hasReports: boolean
    hasSettings: boolean
    hasTimesheet: boolean
    helpUrl: string
    homePageUrl: string
    iconUrl: string
    privacyPolicyUrl: string
    showDashboard: boolean
    defaultNavigationTab: number
}

export const initialize = (props: IUserInfo): Initialize => ({
    type: INITIALIZE,
    ...props,
})

export interface ReceiveHomePageUrl extends Action {
    homePageUrl: string
}

export interface UpdateDefaultNavigationTab extends Action {
    defaultNavigationTab: number
}

export const receiveHomePageUrl = (
    homePageUrl: string,
): ReceiveHomePageUrl => ({ type: RECEIVE_HOME_PAGE_URL, homePageUrl })

export const requestHomePageUrl = (): Action => ({
    type: REQUEST_HOME_PAGE_URL,
})

export const updateDefaultNavigationTab = (
    defaultNavigationTab: number,
): UpdateDefaultNavigationTab => ({
    type: UPDATE_DEFAULT_NAVIGATION_TAB,
    defaultNavigationTab,
})

export const mapDispatchToProps = {
    initialize,
    receiveHomePageUrl,
    requestHomePageUrl,
    updateDefaultNavigationTab,
}

export type DispatchProps = typeof mapDispatchToProps
